import { Controller } from '@hotwired/stimulus';
import * as Sentry from '@sentry/browser';

export default class extends Controller {
  static targets = ['inputField'];

  static values = {
    script: String,
    publicKey: String,
  };

  declare readonly inputFieldTarget: HTMLInputElement;

  declare scriptValue: string;

  declare publicKeyValue: string;

  async connect() {
    const loaded = document.querySelector(`script[src='${this.scriptValue}']`);
    try {
      if (!loaded) {
        await this.loadDeviceManager();
      }
      await this.populateSessionId();
    } catch (error) {
      Sentry.captureException(new Error('socure_device_risk_error', { cause: error }));
    }
  }

  loadDeviceManager() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = this.scriptValue;
      script.setAttribute('data-public-key', this.publicKeyValue);
      script.setAttribute('data-testid', 'deviceRiskScript');
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  async populateSessionId() {
    if (window.SigmaDeviceManager) {
      const deviceSessionId = await window.SigmaDeviceManager.getSessionToken();
      this.inputFieldTarget.value = deviceSessionId;
    } else {
      throw new Error('Sigma Device Manager is not loaded');
    }
  }
}
